// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3kLKj","title":"BackImages_title__3NO9P","images":"BackImages_images__3ruvD"};